import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  TextField,
} from "@mui/material";
import { Visibility, Edit, Delete, Add, Close } from "@mui/icons-material";
import "./PolicyTable.css";

const initialData = [
  { sno: 1, financialYear: "2025-26", version: "v1.0", description: "Employee Leave Policy" },
  { sno: 2, financialYear: "2024-25", version: "v2.0", description: "Salary & Payroll Policy" },
  { sno: 3, financialYear: "2023-24", version: "v1.1", description: "Health Insurance Policy" },
];

const PolicyTable = () => {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [mode, setMode] = useState("add"); // add / edit / view
  const [currentIndex, setCurrentIndex] = useState(null);
  const [policyForm, setPolicyForm] = useState({
    sno: "",
    financialYear: "",
    version: "",
    description: "",
  });

  // Filtered search
  const filteredData = data.filter(
    (row) =>
      row.sno.toString().includes(search) ||
      row.financialYear.toLowerCase().includes(search.toLowerCase()) ||
      row.version.toLowerCase().includes(search.toLowerCase()) ||
      row.description.toLowerCase().includes(search.toLowerCase())
  );

  // Open modal
  const handleOpenModal = (type, index = null) => {
    setMode(type);
    setCurrentIndex(index);
    if (type === "edit" || type === "view") {
      setPolicyForm({ ...data[index] });
    } else {
      setPolicyForm({ sno: "", financialYear: "", version: "", description: "" });
    }
    setOpenModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setPolicyForm({ sno: "", financialYear: "", version: "", description: "" });
    setCurrentIndex(null);
  };

  // Form change
  const handleChange = (e) => {
    setPolicyForm({ ...policyForm, [e.target.name]: e.target.value });
  };

  // Add / Edit save
  const handleSave = () => {
    const { sno, financialYear, version, description } = policyForm;
    if (!sno || !financialYear || !version || !description) {
      alert("All fields are required!");
      return;
    }

    if (mode === "add") {
      setData([...data, policyForm]);
    } else if (mode === "edit") {
      const updated = [...data];
      updated[currentIndex] = policyForm;
      setData(updated);
    }

    handleCloseModal();
  };

  // Delete
  const handleDelete = (index) => {
    if (window.confirm("Delete this policy?")) {
      setData(data.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="policy-wrapper">
      {/* Header */}
      <Box className="policy-header">
        <h2>Company Policies</h2>
        <Box sx={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <input
            type="text"
            placeholder="Search policies..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="policy-search"
          />
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => handleOpenModal("add")}
          >
            Add Policy
          </Button>
        </Box>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} className="policy-table">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Financial Year</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Description</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData.length > 0 ? (
              filteredData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.sno}</TableCell>
                  <TableCell>{row.financialYear}</TableCell>
                  <TableCell>{row.version}</TableCell>
                  <TableCell>{row.description}</TableCell>
                  <TableCell align="center">
                    <IconButton onClick={() => handleOpenModal("view", index)}>
                      <Visibility />
                    </IconButton>
                    <IconButton onClick={() => handleOpenModal("edit", index)} color="warning">
                      <Edit />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(index)} color="error">
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No policies found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Modal */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box className="policy-modal">
          <Box className="modal-header">
            <h3>
              {mode === "add" && "Add Policy"}
              {mode === "edit" && "Edit Policy"}
              {mode === "view" && "View Policy"}
            </h3>
            <IconButton onClick={handleCloseModal}>
              <Close />
            </IconButton>
          </Box>

          <Box className="modal-body">
            <TextField
              name="sno"
              label="S.No"
              type="number"
              value={policyForm.sno}
              onChange={handleChange}
              fullWidth
              margin="dense"
              disabled={mode === "view"}
            />
            <TextField
              name="financialYear"
              label="Financial Year"
              value={policyForm.financialYear}
              onChange={handleChange}
              fullWidth
              margin="dense"
              disabled={mode === "view"}
            />
            <TextField
              name="version"
              label="Version"
              value={policyForm.version}
              onChange={handleChange}
              fullWidth
              margin="dense"
              disabled={mode === "view"}
            />
            <TextField
              name="description"
              label="Description"
              value={policyForm.description}
              onChange={handleChange}
              fullWidth
              margin="dense"
              disabled={mode === "view"}
            />
          </Box>

          {mode !== "view" && (
            <Box className="modal-footer">
              <Button variant="contained" onClick={handleSave}>
                {mode === "add" ? "Add Policy" : "Save Changes"}
              </Button>
            </Box>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default PolicyTable;

